<template>
    <div>
        <h5 class="mb-4">
            <strong>Gestión de palabras de advertencia</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Nombre">
                    <b-form-input v-model="filterWordsOfCautionSga.name" type="text" placeholder="Buscar por nombre"
                        class="form-control" />
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchWordsOfCautionSga">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <el-tooltip effect="light" placement="top" popper-class="py-1 px-2" content="Sincronizar idiomas">
                        <b-button variant="warning" class="ml-1 mr-1" @click="asyncLanguagesWordsOfCautionSga">
                            <i class="fa fa-language" aria-hidden="true"></i>
                        </b-button>
                    </el-tooltip>
                    <b-button variant="primary" @click="createWordOfCautionSga">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Nueva palabra de advertencia'" />
                    </b-button>
                </b-form-group>
            </b-col>

            <b-modal id="modal_create_wordofcaution" size="md" hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Registrar nueva' }} palabra de advertencia
                </template>
                <formWordsOfCaution />
            </b-modal>

            <b-col md="12">

                <b-alert show variant="primary" class="d-flex justify-content-between align-items-center">
                    <div>
                        <i class="fa fa-info-circle mr-1"></i>
                        Mueve los ítems de Palabras de Advertencia para organizar su prioridad según desees.
                    </div>
                    <div class="d-flex justify-content-between align-items-start">
                        <i class="fa fa-list-ul" aria-hidden="true" style="font-size: 20px;"></i>
                        <i class="fa fa-hand-pointer-o mr-1" style="font-size: 40px;"></i>
                    </div>
                </b-alert>
                <b-list-group>
                    <DragAndDropList :items="getItemsWordsOfCautionSga" :onDragDrop="onHandleDragDrop">
                        <template #default="{ item }">
                            <b-list-group-item
                                class="d-flex justify-content-between align-items-center list-group-item flex-wrap" :class="item.is_active ? 'active' : 'inactive'">
                                <div class="d-flex justify-content-between align-items-center list-group-item-header">
                                   <div class="list-group-item-header-items d-flex align-items-center">
                                    <svg width="35" height="40" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="4.5" cy="2.5" r=".6" fill="darkgray" />
                                        <circle cx="4.5" cy="4.5" r=".6" fill="darkgray" />
                                        <circle cx="4.5" cy="6.499" r=".6" fill="darkgray" />
                                        <circle cx="4.5" cy="8.499" r=".6" fill="darkgray" />
                                        <circle cx="4.5" cy="10.498" r=".6" fill="darkgray" />
                                        <circle cx="4.5" cy="12.498" r=".6" fill="darkgray" />
                                        <circle cx="6.5" cy="2.5" r=".6" fill="darkgray" />
                                        <circle cx="6.5" cy="4.5" r=".6" fill="darkgray" />
                                        <circle cx="6.5" cy="6.499" r=".6" fill="darkgray" />
                                        <circle cx="6.5" cy="8.499" r=".6" fill="darkgray" />
                                        <circle cx="6.5" cy="10.498" r=".6" fill="darkgray" />
                                        <circle cx="6.5" cy="12.498" r=".6" fill="darkgray" />
                                        <circle cx="8.499" cy="2.5" r=".6" fill="darkgray" />
                                        <circle cx="8.499" cy="4.5" r=".6" fill="darkgray" />
                                        <circle cx="8.499" cy="6.499" r=".6" fill="darkgray" />
                                        <circle cx="8.499" cy="8.499" r=".6" fill="darkgray" />
                                        <circle cx="8.499" cy="10.498" r=".6" fill="darkgray" />
                                        <circle cx="8.499" cy="12.498" r=".6" fill="darkgray" />
                                        <circle cx="10.499" cy="2.5" r=".6" fill="darkgray" />
                                        <circle cx="10.499" cy="4.5" r=".6" fill="darkgray" />
                                        <circle cx="10.499" cy="6.499" r=".6" fill="darkgray" />
                                        <circle cx="10.499" cy="8.499" r=".6" fill="darkgray" />
                                        <circle cx="10.499" cy="10.498" r=".6" fill="darkgray" />
                                        <circle cx="10.499" cy="12.498" r=".6" fill="darkgray" />
                                    </svg>
                                    <b-badge variant="info" class="mr-2 ml-3 p-2">
                                        <h4 class="m-0 text-white text-normal"><strong>{{ item.priority }}</strong></h4>
                                        <span class="text-white text-normal">PRIORIDAD</span>
                                    </b-badge>
                                   </div>
                                    <div class="list-group-item-header-items-text">
                                        <h6><strong class="ml-1">{{ item.name }}</strong></h6>
                                        <span class="d-block text-muted ml-1">{{ item.user.name }}</span>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between align-items-center flex-wrap list-group-item-body">
                                    <el-tooltip content="Editar" placement="top" effect="light">
                                        <el-button type="text" class="text-primary" @click="editWordOfCaution(item)">
                                            <i class="fa fa-edit fa-lg"></i>
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip class="ml-2" :content="item.is_active ? 'Inactivar' : 'Activar'"
                                        placement="top" effect="light">
                                        <el-button type="text" @click="changeStatus(item.id)"
                                            :class="`${!item.is_active ? 'text-success' : 'text-danger'}`">
                                            <i :class="`fa fa-lg ${!item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                        </el-button>
                                    </el-tooltip>
                                </div>
                            </b-list-group-item>
                        </template>
                    </DragAndDropList>

                </b-list-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>

// Generales
import { mapActions, mapState, mapMutations } from 'vuex';

// Componentes
import formWordsOfCaution from './FormWordsOfCaution.vue';
import DragAndDropList from '../../../../../shared/components/DragAndDropList.vue';


export default {
    name: 'WordsOfCaution',
    components: {
        formWordsOfCaution,
        DragAndDropList
    },

    computed: {

        ...mapState('sgaWordsOfCaution', [
            'wordsOfCautionSga', 
            'action', 
            'filterWordsOfCautionSga',
            'wordOfCaution'
        ]),

        getItemsWordsOfCautionSga() {
            return (this.wordsOfCautionSga && this.wordsOfCautionSga && typeof this.wordsOfCautionSga === 'object') ? this.wordsOfCautionSga : []
        }

    },

    methods: {
        ...mapActions('sgaWordsOfCaution', [
            'getWordsOfCautionSga', 
            'changeStatusWordOfCautionSga', 
            'showWordOfCautionSga', 
            'asyncLanguagesWordsOfCautionSga', 
            'updatePrioritiesWords'
        ]),
        ...mapMutations('sgaWordsOfCaution', [
            'setActionWordOfCautionSga', 
            'setDefaultFilterWordsOfCaution', 
            'setWordOfCautionSga'
        ]),

        createWordOfCautionSga() {
            this.setActionWordOfCautionSga('create');
            this.$bvModal.show('modal_create_wordofcaution');
        },

        async clearFilter() {
            this.setDefaultFilterWordsOfCaution();
            await this.getWordsOfCautionSga();
        },

        async changeStatus(id) {
            await this.changeStatusWordOfCautionSga(id);
            await this.getWordsOfCautionSga();
        },

        editWordOfCaution(wordOfCaution) {
            this.showWordOfCautionSga(wordOfCaution.id);
            this.setActionWordOfCautionSga('edit');
            this.$bvModal.show('modal_create_wordofcaution');
        },

        async searchWordsOfCautionSga() {
            await this.getWordsOfCautionSga(true);
        },

        async onHandleDragDrop(allItems, prevPosition, nextPosition, useConditionalItemsEquals) {
            if (prevPosition === nextPosition && useConditionalItemsEquals) return 

            await this.updatePrioritiesWords({ words : allItems.map((_x, index) => ({ ... _x, priority: index+1 }) ) });
            await this.searchWordsOfCautionSga();  
        },

    },
};
</script>

<style scoped>
.list-group-item {
    border: 1px solid white;
    -webkit-box-shadow: 0 2px 17px -3px #ccc;
    box-shadow: none;
    margin-bottom: 4px;
    background-color: #fcfcfc;
    border-radius: 5px;
    color: black;
}

.list-group-item:hover {
    cursor: pointer;
    background-color: #f4f4f4;
    border: 1px solid #f8f8f8;
}

.list-group-item .active {
   border-left: 4px solid rgb(38, 130, 167) !important; 
}

.list-group-item .inactive {
    border-left: 4px solid rgb(195, 80, 80) !important; 
}

@media (min-width: 0px) and (max-width: 500px) {

    .list-group-item {
        padding: 5px;
        position: relative;
        margin-bottom: 26px;
    }

    .list-group-item button span i {
        font-size: 29px;
    }

    .list-group-item-header {
        display: block !important;
        width: 100%;
    }

    .list-group-item-header-items {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .list-group-item-header-items .badge-info {
        width: 100%;
        height: 35px;
        padding: 7px !important;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    .list-group-item-header-items .badge-info p,
    .list-group-item-header-items .badge-info span,
    .list-group-item-header-items .badge-info h4 {
        padding: 0px; 
        margin: 0px;
        font-size: 12px;
    }

    .list-group-item-header-items-text {
        margin-top: 4px;
    }

    .list-group-item-body {
        display: flex !important;
        justify-content: center !important;
        width: 100%;
        position: absolute;
        bottom: -30px;
    }
}

</style>